import { NotesTabPanel } from "@/pages/notes/components/NotesTabPanel";

export function NotesTab({ id }: { id: string }) {
  return <NotesTabPanel ownerType="spv_pool" ownerId={id} />;
}
